import clsx from "clsx";
import Switch from "react-bootstrap/Switch";
import TooltipIcon from "../../../../../components/TooltipIcon";
import Typography from "../../../../../components/typography/Typography";

interface ReanalyzeSwitchInputProps {
  disabled?: boolean;
  value?: boolean;
  onToggle: () => void;
  label?: string;
  tooltip?: string;
}

const ReanalyzeSwitchInput = ({
  disabled,
  value,
  onToggle,
  label,
  tooltip
}: ReanalyzeSwitchInputProps) => (
  <div
    className={clsx(
      "d-flex justify-content-start p-15 w-100 flex-grow-1 flex-gap-2",
      {
        "background-color-disabled": disabled,
        "cursor-default": disabled
      }
    )}
    style={{ flexDirection: "column" }}
  >
    <div className="d-flex align-items-center flex-gap-2">
      <Typography
        variant={"subtitle6"}
        className={"text-color-gray-60 text-uppercase"}
        style={{ fontSize: 10 }}
      >
        {label}
      </Typography>
      {tooltip && (
        <TooltipIcon
          icon="info-circle"
          message={tooltip}
          data-testid={`rlcs_configuration_info_tooltip_icon_${label}`}
        />
      )}
    </div>
    <Switch
      name={label}
      onChange={() => {
        if (disabled) {
          return;
        }

        onToggle();
      }}
      checked={disabled ? false : value}
      label={""}
      disabled={disabled}
      data-testid={`rlcs_configuration_switch_${label}`}
    />
  </div>
);

export default ReanalyzeSwitchInput;
